import React, { useState, useRef } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Overlay from 'react-bootstrap/Overlay';
import Tooltip from 'react-bootstrap/Tooltip';


const _props = {
    show: false,
    placement: 'right',
    messageJsx: <></>,
    children: <></>,
    id: '',
    className: ''
}
export function AppTooltip(props = _props) {

    <div class="tooltip-arrow" style="position: absolute; top: 0px; transform: translate3d(0px, 0px, 0px);"></div>
    const popover = (
        <div className={props.className} id={props.id}>
            <div>

            </div>
            {props.messageJsx}
        </div>
    );

    return <OverlayTrigger show={props.show} placement="right" overlay={popover}>
        {props.children}
    </OverlayTrigger>
}